import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tg-centering-flex',
  templateUrl: './centering-flex.component.html',
  styleUrls: ['./centering-flex.component.scss']
})
export class CenteringFlexComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
